// extracted by mini-css-extract-plugin
module.exports = {"helsinkiCityOwnedSpan":"helsinkiCityOwnedIcon_helsinkiCityOwnedSpan__efD7_","helsinkiCityOwnedIcon":"helsinkiCityOwnedIcon_helsinkiCityOwnedIcon__t4_fO"};